import { render } from "./EncabezadoMenuComponent.vue?vue&type=template&id=c5213b8c&scoped=true"
import script from "./EncabezadoMenuComponent.vue?vue&type=script&lang=js"
export * from "./EncabezadoMenuComponent.vue?vue&type=script&lang=js"

import "./EncabezadoMenuComponent.vue?vue&type=style&index=0&id=c5213b8c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5213b8c"]])

export default __exports__